import type { ShippingProviderName } from 'ecosystem'
import type { BuiltShipment } from './buildShipmentFromPostnord'

/**
 * Minimal `shipments[0]` payload for the cases where there's no carrier
 * booking server-side (DEFAULT branch, or a brand-side widget that books
 * later). The BE still expects a `shipments[]` array, so this seeds it
 * with the provider — when one of the real carriers (`POSTNORD` / `NSHIFT`
 * / `INGRID`) — and an optional pre-minted shipment id.
 *
 * `provider === 'DEFAULT'` is an FE-only sentinel meaning "no carrier".
 * The BE's `ShippingProvider` enum only accepts the three real carriers,
 * so we omit the field entirely in that case (Jackson is happy with null).
 */
export const buildShipmentFromDefault = ({
  provider,
  shipmentId
}: {
  provider: ShippingProviderName
  shipmentId?: string
}): BuiltShipment => ({
  shipment: {
    ...(provider !== 'DEFAULT' ? { shippingProvider: provider } : {}),
    ...(shipmentId ? { shipmentId } : {})
  }
})
